import { AbstractBlock } from './AbstractBlock'
import { FloatingBlock, FloatingIdleBlock } from './FloatingBlock'

export class FixedBlock extends AbstractBlock {
  constructor ({ id, start, time, part, color, description, kind }, prev = null, next = null) {
    super({
      id,
      kind,
      type: 'fixed',
      part,
      die: null,
      color,
      startup: 0,
      shutdown: 0,
      start,
      time
    }, prev, next)
  }

  /**
   *
   * @param i
   * @param id
   * @returns {{part: string, i: *, style: {background: *}, beginTime: number, endTime: *, id: *}[]}
   */
  getCells (i, id) {
    return [
      {
        beginTime: +this.start,
        endTime: +this.start + this.time,
        style: {
          'background': this.color
        },
        part: `${this.id}-${id}`,
        desc: `${this.kind.charAt(0).toUpperCase() + this.kind.slice(1)} (Fixed)`,
        i,
        id
      }
    ]
  }

  /**
   *
   * @param block
   */
  prepend (block) {
    if (this._prev) {
      throw new Error('Can only prepend to a head block!')
    }

    if (this.start === block.end || this.isOutage) {
      block.linkNext(this)
    } else if (this.start > block.end) {
      block.linkNext(new FloatingIdleBlock(block.end, this.start - block.end, block, this))
    } else {
      let rest = new FloatingBlock(block.obj)
      rest.link(this, this._next)
      rest.start = this.end
      rest.time = block.end - this.start
      block.time -= rest.time
      block.linkNext(this)
    }
  }

  /**
   *
   * @param block
   */
  append (block) {
    if (block.type === 'fixed' && block.start >= this.start && block.end <= this.end) {
      throw new Error('Cannot insert overlapping fixed blocks')
    }

    block.link(this, this._next)
    this.bubbleNext()
  }

  bubbleNext () {
    if (this._prev && this.start < this._prev.end) {
      if (this._prev.type === 'fixed') {
        throw new Error('Overlapping blocks are not allowed')
      }

      if (this._prev.start >= this.start) {
        let next = this._next
        this.link(this._prev._prev, this._prev)
        this._next.linkNext(next)
        this.bubbleNext()
        return
      } else {
        let rest = new FloatingBlock(this._prev.obj)
        rest.link(this, this._next)
        rest.start = this.end
        rest.time = this._prev.end - this.start
        this._prev.time -= rest.time
      }
    }

    super.bubbleNext()
  }

  /**
   *
   * @param block
   */
  resolve (block) {
    throw new Error('Calling resolve on a fixed block. Cannot split a fixed block!')
  }

  /**
   *
   * @param time
   */
  pull (time) {
    if (this._next) {
      this._next.pull(time)
    }
  }
}
